import { BottomSheet } from 'shared/ui/BottomSheet'
import { Text, TextAlign, TextSize, TextWeight } from 'shared/ui/Text/Text'
import cls from './SubscribeFloat.module.scss'
import { Button } from 'shared/ui/Button'
import logo from 'shared/assets/MineCards-Logo-Rounded.svg'
import { IconBadge, TelegramIcon } from 'shared/ui/Icon'

export const SubscribeFloat = (props) => {
    const { closeSubscribeFloat, onSubscribe, open = true } = props

    return (
        <BottomSheet
            label="Подписаться на наш канал"
            onOpenChange={(open) => !open && closeSubscribeFloat()}
            open={open}
        >
            <div className={cls.ImageContainer}>
                <img className={cls.Image} alt="MineCards" src={logo} />
                <IconBadge className={cls.Icon}>
                    <TelegramIcon />
                </IconBadge>
            </div>
            <Text
                className={cls.TitleTextFloat}
                size={TextSize.XL}
                align={TextAlign.LEFT}
                weight={TextWeight.BOLD}
            >
                Хочешь больше?
            </Text>
            <Text
                className={cls.TextFloat}
                align={TextAlign.LEFT}
                weight={TextWeight.MED}
            >
                Подпишись на наш канал, чтобы узнавать об обновлениях и новинках
            </Text>
            <Button
                onClick={onSubscribe}
                className={cls.FloatButton}
                text={'Подписаться на наш канал'}
            />
        </BottomSheet>
    )
}
